import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveJobMiscCost = async (jobMiscCost, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      let Payload = {
        miscCostID: jobMiscCost.miscCostID,
        jobID: jobMiscCost.jobID,
        costName: jobMiscCost.costName,
        costDescription: jobMiscCost.costDescription,
        billToCustomer: jobMiscCost.billToCustomer,
        sortOrder: jobMiscCost.sortOrder,
        budgetedCostAmount: jobMiscCost.budgetedCostAmount,
        budgetedCustomerPrice: jobMiscCost.budgetedCustomerPrice,
        actualCostAmount: jobMiscCost.actualCostAmount,
        actualCustomerPrice: jobMiscCost.actualCustomerPrice
      };
      const response = await fetch(`${dev_baseUrl}/JobMiscCost/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else{
        return data;
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
